export class ActivityExpiration {
  onFinished: () => void;
  private INACTIVITY_LIMIT = 30 * 60 * 1000; // 30 minutes
  private inactivityTimer: NodeJS.Timeout | null = null;
  private events: string[] = [
    "mousemove",
    "keydown",
    "scroll",
    "click",
    "touchstart",
  ];

  constructor({
    onInactivity,
    timeout,
    onFinished,
  }: {
    timeout?: number;
    onInactivity?: () => void;
    onFinished: (e: ActivityExpiration) => void;
  }) {
    console.log("ActivityExpiration initialized with timeout:", timeout);
    if (onInactivity) this.onInactivity = onInactivity;

    if (timeout) this.INACTIVITY_LIMIT = timeout;

    this.onFinished = () => onFinished(this);

    this.resetInactivityTimer = this.resetInactivityTimer.bind(this);
    this.onInactivity = this.onInactivity.bind(this);
  }

  onInactivity: () => void = () => {
    console.log("User has been inactive for 30 minutes.");
    // You can place your custom logic here (e.g., logout, show a warning, etc.)
  };

  setOnInactivity(callback: () => void) {
    this.onInactivity = callback;
  }

  // Events to detect user activity
  public onStart() {
    this.events.forEach((event) => {
      window.addEventListener(event, this.resetInactivityTimer, true);
    });
  }

  public onDestroy() {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
      this.inactivityTimer = null;
    }

    // Remove event listeners to prevent memory leaks
    this.events.forEach((event) => {
      window.removeEventListener(event, this.resetInactivityTimer, true);
    });
  }

  // Initialize the timer when the page loads
  setTimeout(number: number) {
    this.INACTIVITY_LIMIT = number * 60 * 1000; // Convert minutes to milliseconds
    this.resetInactivityTimer();
  }

  // Reset the inactivity timer whenever the user interacts with the page
  resetInactivityTimer() {
    if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
    this.inactivityTimer = setTimeout(this.onInactivity, this.INACTIVITY_LIMIT);
  }
}
